export default {
  submitData: state => state.auth.submitData,
  userInfo: state => state.auth.userInfo,
  faceInInfo: state => state.auth.faceInInfo,
}

